<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i
            ><span
                >{{ $t("app.links.budget_requests")
                }}<budget-forms-list :curFormSelect="'/form01-123'"
            /></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
                @downloadDeltaRep="downloadDeltaRep"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <p v-if="!categoryMode" class="title">
                    {{ getCommonText("decoding") }}. {{ categoryName }}
                </p>
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="
                        categoryMode &&
                        !isGkkpMode &&
                        !(progress < 100) &&
                        variantAttribute
                    "
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadCategoryData"
                />
                <div class="filter-actions filter-actions-flex">
                    <template v-if="categoryMode">
                        <c-budget-forms-copy-data
                            v-if="
                                !(progress < 100) &&
                                variantAttribute &&
                                header.year < header.cur_year + 2
                            "
                            :budgetForm="budgetForm"
                            :header="{
                                ...header,
                                expense_codes_next_year:
                                    expenseCodesActualNextYear,
                            }"
                            :isLoad="isLoad || !isFormCanBeCopied"
                            @keyPress="keyPress"
                        />
                        <b-button
                            variant="primary"
                            @click="addItem"
                            v-if="variantAttribute"
                            :disabled="isLoad"
                            ><i class="icon icon-plus-circle"></i>
                            {{ getCommonText("add") }}</b-button
                        >
                    </template>
                    <template v-else>
                        <b-button variant="light" @click="resetModal">
                            <i class="icon icon-keyboard icon-rotate-180"></i>
                            {{ getCommonText("back_to_list") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            v-if="variantAttribute"
                            variant="primary"
                            @click="$refs.formTemplate.addItem()"
                        >
                            <i class="icon icon-plus-circle"></i
                            >{{ getCommonText("add") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            :disabled="!dataChanged || isLoad"
                            variant="success"
                            @click="prepareForSaveDecodes"
                        >
                            {{ getCommonText("save") }}
                        </b-button>
                    </template>
                </div>
            </div>
        </div>

        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="isLoad" rounded="sm">
                <b-overlay :show="mainTableOverlay" rounded="sm">
                <b-table
                    :fields="tableFields"
                    :items="budgetForm"
                    responsive="true"
                    bordered
                    head-variant="light"
                    sticky-header="true"
                    no-border-collapse
                >
                    <template #top-row="data">
                        <td></td>
                        <td class="td-numbering"></td>
                        <td class="td-numbering text-center table-success">
                            1
                        </td>
                        <td class="td-numbering text-center table-danger">2</td>
                        <td class="td-numbering text-center table-info">3</td>
                        <td class="td-numbering text-center table-primary">
                            4
                        </td>
                        <td class="td-numbering text-center table-warning">
                            5
                        </td>
                        <td class="td-numbering text-center table-success">
                            6
                        </td>
                        <td class="td-numbering"></td>
                    </template>
                    <template #head(selection)>
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="(e) => setIsAllDelete(e)"
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #head(more)>
                        <div class="text-center">
                            <i
                                :title="getCommonText('del_selected')"
                                class="icon icon-close table-all-remove"
                                @click="
                                    deleteItem(
                                        `${
                                            selectAll
                                                ? getCommonText('all_cats')
                                                : getCommonText('selected_cats')
                                        }`
                                    )
                                "
                            />
                        </div>
                    </template>
                    <template #cell(selection)="data">
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="data.item.itemToDelete"
                                @input="
                                    (e) => {
                                        if (!e) selectAll = false;
                                    }
                                "
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #cell(action)="data">
                        <button
                            class="table-plus"
                            v-b-modal.goods-modal
                            @click="setCurrCatName(data.item)"
                            :disabled="
                                data.item.checkForDuplicates ||
                                !data.item.curr_code
                            "
                        >
                            <i class="icon icon-plus-circle" />
                        </button>
                    </template>
                    <template #cell(name_code)="data">
                        <div class="column-width-100">
                            <multiselect
                                v-if="variantAttribute && !data.item.cat_sum"
                                v-model="data.item.curr_code"
                                :label="`name_${lng}`"
                                :placeholder="getFormText('select_region')"
                                :options="actualRegions"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                @input="onNameCodeChanged(data.item)"
                            >
                            </multiselect>
                            <div v-else>
                                {{ data.item.curr_code[`name_${lng}`] }}
                            </div>
                        </div>
                    </template>
                    <template #cell(cat_sum)="data">
                        <div class="text-right">
                            {{ $n(data.item.cat_sum) }}
                        </div>
                    </template>
                    <template #cell(recipient)="data">
                        <div class="column-width-100 bp-category-name">
                            <div>{{ data.item["recipient_" + lng] }}</div>
                            <i
                                v-if="variantAttribute && data.item.curr_code"
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="
                                    showEditModal(
                                        data.item,
                                        'setRecipientModal'
                                    )
                                "
                            ></i>
                        </div>
                    </template>
                    <template #cell(purpose)="data">
                        <div class="column-width-100 bp-category-name">
                            <div>{{ data.item["purpose_" + lng] }}</div>
                            <i
                                v-if="variantAttribute && data.item.curr_code"
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="
                                    showEditModal(data.item, 'setPurposeModal')
                                "
                            ></i>
                        </div>
                    </template>
                    <template #cell(justif)="data">
                        <div class="column-width-100 bp-category-name">
                            <div>{{ data.item["justif_" + lng] }}</div>
                            <i
                                v-if="variantAttribute && data.item.curr_code"
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="
                                    showEditModal(data.item, 'setJustifModal')
                                "
                            ></i>
                        </div>
                    </template>
                    <template #cell(files)="data">
                        <span
                            class="blue pointer underline"
                            @click="
                                onAllFilesClick({
                                    ...data.item,
                                    name_ru: data.item.curr_code[`name_${lng}`],
                                })
                            "
                            >({{
                                data.item.files ? data.item.files.length : 0
                            }})</span
                        >
                    </template>
                    <template #cell(more)="data">
                        <i
                            class="icon icon-clear table-remove"
                            v-if="variantAttribute"
                            :disabled="deletingCat"
                            @click="
                                deleteItem(getCommonText('curr_cat'), data.item)
                            "
                        ></i>
                    </template>

                    <template #bottom-row="data">
                        <td class="text-right" colspan="3">
                            {{ getCommonText("total") }}
                        </td>
                        <td class="text-right">{{ $n(total) }}</td>
                        <td colspan="5"></td>
                    </template>
                </b-table>
                </b-overlay>
                <div
                    class="table-add"
                    v-if="variantAttribute"
                    :disabled="isLoad"
                >
                    <span @click="addItem"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="isLoad" rounded="sm">
                <form-template10
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lang="lng"
                    :lng_kz="lng_kz"
                    :allFiles="allFiles"
                    :isLoad="isLoad"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :projectsBankFormData="projectsBankFormData"
                    :isValErrShowed="isValErrShowed"
                    :decodeControl="decodeControl"
                    @addOrderNumber="addOrderNumber"
                    @setIsAllDelete="setIsAllDelete"
                    @deleteRows="deleteRows"
                ></form-template10>
                <div class="table-add" v-if="variantAttribute">
                    <span @click="$refs.formTemplate.addItem()"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </template>
        <files-updown 
            v-if="isFilterReady"
            ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="isLoad"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
        >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setRecipientModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'recipient_ru', kk: 'recipient_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('recipient')"
            :textareaTitleRu="this.getFormText('recipient_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('recipient_textarea_title_kk')"
            :placeHolder="this.getFormText('recipient_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="saveItem"
        />
        <c-set-b-f-category-name
            ref="setPurposeModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'purpose_ru', kk: 'purpose_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('purpose')"
            :textareaTitleRu="this.getFormText('purpose_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('purpose_textarea_title_kk')"
            :placeHolder="this.getFormText('purpose_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="saveItem"
        />
        <c-set-b-f-category-name
            ref="setJustifModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'justif_ru', kk: 'justif_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('justif')"
            :textareaTitleRu="this.getFormText('justif_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('justif_textarea_title_kk')"
            :placeHolder="this.getFormText('justif_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="saveItem"
        />
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import FilesUpdown from "@/modules/budget-request/FilesUpdown";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import FormsHandlerMixin from "@/modules/budget-request/mixins/forms-handler-mixin";
import FormTemplate10 from "@/modules/budget-request/components/budget-forms-template10.vue";
import ModalAllFilesManagement from "@/modules/budget-request/components/modal-all-files-management.vue";
import CBudgetFormsCopyData from "@/modules/budget-request/components/budget-forms-copy-data.vue";
import FormsDownloadReprt from "@/modules/budget-request/components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from "@/modules/budget-request/components/budget-forms-data-transfer.vue";
import CSetBFCategoryName from "../components/c-set-bf-category-name.vue";

export default {
    name: "Form359",
    components: {
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        FormTemplate10,
        ModalAllFilesManagement,
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        CBudgetFormsDataTransfer,
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: "359",
                name_kk: "",
                name_ru: "",
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            dict: [],
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            actualRegions: [],
            projectsBankFormData: [],
            isValErrShowed: false,
            expenseCodesActualNextYear: [],
            isGoodsDataValid: false
        };
    },
    created() {
        this.$emit("setForm", this.form);
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        categoryMode() {
            this.$emit("setCategoryMode", this.categoryMode);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        },
        lng_kz() {
            this.sortProjectsBankFormData();
        },
        goodsData: {
            handler() {
                const hasDataToSave = this.goodsData.some(
                    (gd) => gd.rowToSave
                );
                this.setDataChanged(hasDataToSave);

                const isHasEmptyCurrExpenseCode = this.goodsData.some(
                    (gd) => !gd.curr_expense_code
                );
                this.isValErrShowed = isHasEmptyCurrExpenseCode;
                
                const hasNotValidRow = this.goodsData.some(
                    (gd) => 'isDataValid' in gd && gd.isDataValid === false
                );
                this.isGoodsDataValid = !hasNotValidRow;
            },
            deep: true,
        },
    },
    methods: {
        itemUpdate(item) {
            this.$set(item, "curr_code", null);
            this.$set(item, "cat_sum", 0);
            this.$set(item, "recipient_ru", "");
            this.$set(item, "recipient_kk", "");
            this.$set(item, "purpose_ru", "");
            this.$set(item, "purpose_kk", "");
            this.$set(item, "justif_ru", "");
            this.$set(item, "justif_kk", "");
            this.$set(item, "newCat", true);
            this.$set(item, "category_id", this.uuidv4());
            this.$set(item, "checkForDuplicates", false);
            this.$set(item, "isDataValid", false);
            this.$set(item, "itemToDelete", false);
            this.addGetParams(item);
        },

        addGetParams(item) {
            Object.defineProperty(item, "code", {
                get: () => {
                    if (item.curr_code && "code" in item.curr_code) {
                        return item.curr_code.code;
                    } else {
                        return null;
                    }
                },
            });
        },

        onNameCodeChanged(item) {
            this.disableSelectedCodes();
            this.checkForDuplicates("code");
            if (!this.areDoublesFound) {
                this.save(item, true);
            }
        },

        saveItem(item) {
            this.save(item, true);
        },

        async save(item, isSaveCat = false) {
            this.isLoad = true;

            this.setIsCopyRowsBtnVisible(false);
            const data = {
                isSaveCat: isSaveCat,
                values: item,
                header: this.header,
                total: this.total,
            };
            try {
                const response = await fetch("/api-py/save-brform359/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                if (response.ok) {
                    const result = await response.json();
                    if ("result" in result && result["result"] == "success") {
                        if (isSaveCat) {
                            if ("new_id" in result) {
                                this.$set(item, "id", result["new_id"]);
                            }
                        } else {
                            if ("new_ids" in result) {
                                result["new_ids"].forEach((ids) => {
                                    const savedRow = this.goodsData.find(
                                        (gd) => gd.id === ids["old_id"]
                                    );
                                    if (savedRow)
                                        this.$set(
                                            savedRow,
                                            "id",
                                            ids["new_id"]
                                        );
                                });
                            }
                            this.resetDecodes();

                            this.makeToast(
                                "success",
                                this.getErrText("msg"),
                                this.getErrText("saved")
                            );
                        }
                        if (!isSaveCat) this.loadCategoryData();
                    } else {
                        this.makeToast(
                            "danger",
                            this.getErrText("not_saved"),
                            "Error"
                        );
                    }
                } else {
                    this.makeToast(
                        "danger",
                        this.getErrText("not_saved"),
                        "Error:" + response.status
                    );
                }
            } catch (e) {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    e.toString()
                );
            } finally {
            }
            this.selectAll = false;

            this.isLoad = false;
        },

        resetDecodes() {
            this.goodsData.forEach((item) => {
                this.$set(item, "isNew", false);
                this.$set(item, "rowToSave", false);
                this.$set(item, "itemToDelete", false);
                this.$set(item, "isHasDouble", false);
                this.$set(item, "isDataValid", true);
            });
        },

        disableSelectedCodes() {
            this.actualRegions.forEach((item) => {
                const isRegionSelected = this.budgetForm.some(
                    (bf) => bf.code === item.code
                );
                this.$set(item, "$isDisabled", isRegionSelected);
            });
        },

        showEditModal(row, modalRef) {
            if (!row.curr_code) return;

            const modal = this.$refs[modalRef];
            if (modal) modal.showModal(row);
        },

        deleteItem(msg, row = false) {
            if (
                !this.variantAttribute ||
                this.isLoad ||
                (!row &&
                    this.budgetForm.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;

            if (row) this.currCategory = row.category_id;

            this.$bvModal
                .msgBoxConfirm(
                    this.getCommonText("del_with_decodes", { msg: msg }),
                    {
                        title: this.getCommonText("confirm"),
                        size: "lg",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: this.getCommonText("yes"),
                        cancelTitle: this.getCommonText("cancel"),
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(async (value) => {
                    if (value) {
                        this.deletingCat = true;
                        if (row) {
                            if (row.id >= 0) {
                                this.deleteRows([row], "category");
                            } else {
                                const idxToDel = this.budgetForm.findIndex(
                                    (itm) => itm.id === row.id
                                );
                                this.budgetForm.splice(idxToDel, 1);
                            }
                        } else {
                            const existingRowsToDel = this.budgetForm.filter(
                                (item) => item.id >= 0 && item.itemToDelete
                            );
                            this.budgetForm = this.budgetForm.filter(item => !item.itemToDelete);

                            if (!existingRowsToDel.length) {
                                this.selectAll = false;
                            } else {
                                await this.deleteRows(
                                    existingRowsToDel,
                                    "category"
                                );
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.makeToast(
                        "danger",
                        this.getCommonText("on_del"),
                        error.toString()
                    );
                });
        },

        async loadGoodsData(cat) {
            this.isLoad = true;
            await this.getProjectsBankFormData();
            if (!cat.code) {
                this.isLoad = false;
                return;
            }
            this.initialGoodsData = {};

            const newHeader = { ...this.header, cat_code: cat.category_id };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-goods/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(newHeader),
                    }
                );
                if (response.status === 200) {
                    const values = await response.json();

                    values.forEach((val) => {
                        this.$set(val, "isNew", false);
                        this.$set(val, "rowToSave", false);
                        this.$set(
                            val,
                            "curr_expense_code",
                            this.getCurrExpenseCode(val["expense_code"])
                        );
                        this.$set(val, "itemToDelete", false);
                        this.$set(val, "isHasDouble", false);
                        this.$set(val, "isDataValid", true);

                        // this.addGetParams(val);

                        this.initialGoodsData[val.id] = {
                            ...val,
                            total: val.total,
                        };
                    });
                    this.goodsData = values;
                    this.addOrderNumber(this.goodsData);
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadGoodsData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        }, // загрузка списка расшифровок

        getCurrExpenseCode(expenseCode) {
            const curProject = this.projectsBankFormData.find(
                (itm) => itm.expense_code === expenseCode
            );
            return curProject || null;
        },

        changeGroup(item) {
            this.$set(item, "group", item.group_obj.value.code);
        },

        onChangeName(value) {
            if (!value.group_obj) return;
            this.changeGroup(value);
            this.checkForDuplicates();
        },

        afterDeleted() {
            this.checkForDuplicates();
            this.disableSelectedCodes();
        },

        checkForDuplicates() {
            const existingItems = {};
            for (const [idx, item] of this.budgetForm.entries()) {
                const curCode = item.code;
                if (existingItems.hasOwnProperty(curCode)) {
                    this.budgetForm[
                        existingItems[curCode]
                    ].checkForDuplicates = true;
                    item.checkForDuplicates = true;
                    this.areDoublesFound = true;
                    break;
                } else {
                    item.checkForDuplicates = false;
                    existingItems[curCode] = idx;
                }
                this.areDoublesFound = false;
            }
        },

        async deleteRows(items, mode) {
            this.isLoad = true;
            const data = {
                item: items,
                header: this.header,
                mode: mode,
                form: this.form.code,
            };
            try {
                const response = await fetch(
                    "/api-py/delete-list-budget-request-form/",
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    const updateOnlyCategory = mode === "category";
                    await this.updateDatas(updateOnlyCategory);
                    this.makeToast(
                        "success",
                        this.getErrText("msg"),
                        this.getErrText("one_deleted")
                    );
                }
            } catch {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    this.getErrText("on_del")
                );
            }
            this.isLoad = false;
        }, // удаление данных

        getFiles(data) {
            this.files = data;
        },

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            );
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        getFormCode() {
            // при необходимости заменить в родительском компоненте. Напр. Form01_142.vue
            return `${this.form.code}-decode`;
        },

        async loadCategoryData() {
            this.selectAll = false;
            this.isLoad = true;
            this.budgetForm.splice(0);
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-cat/" +
                        JSON.stringify(this.header)
                );
                if (response.ok) {
                    const values = await response.json();
                    values.forEach((val, i) => {
                        const item = { ...val };
                        const curr_code = this.actualRegions.find(
                            (itm) => itm.code === val.saved_code
                        );
                        this.$set(item, "curr_code", curr_code || null);
                        this.$set(item, "newCat", false);
                        this.$set(item, "files", this.getUnicFilesArr(val)),
                            this.$set(item, "checkForDuplicates", false);
                        this.$set(item, "itemToDelete", false),
                            this.addGetParams(item);
                        this.budgetForm.push(item);
                    });
                    this.disableSelectedCodes();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadCategoryData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
            this.isValErrShowed = false;
            this.getSavedProjectCodesActualNextYear();

        },

        async loadDict() {
            await this.getActualRegions();
        },

        async getActualRegions() {
            const data = {
                cur_region: this.header.region_code,
                var_start: this.header.variant_date_time,
                var_end: this.header.variant_end_date,
                first_data_of_year: this.header.first_date_of_year_gu,
            };
            try {
                const response = await fetch(
                    `/api-py/get-actual-region-names/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    const items = await response.json();
                    this.actualRegions = items;
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} getActualRegions`,
                    error.toString()
                );
            }
        },

        async getProjectsBankFormData() {
            const data = {
                category_region: this.currCategory.code,
                filter_region: this.header.id_region,
                cur_year: this.header.cur_year,
                year: this.header.year,
                abp: this.header.abp,
                prg: this.header.prg,
                ppr: this.header.ppr,
                transfer_groups: ['01', '03', '06']
            };
            try {
                const response = await fetch(
                    `/api-py/get-project-bank-form-data-with-names/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    const items = await response.json();
                    this.projectsBankFormData = items;
                    this.sortProjectsBankFormData();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} getProjectsBankFormData`,
                    error.toString()
                );
            }
        },

        async getSavedProjectCodesActualNextYear() {
            try {
                const response = await fetch(
                    "/api-py/get-saved-project-codes-actual-next-year/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(this.header),
                    }
                );
                if (response.ok) {
                    const items = await response.json();
                    this.expenseCodesActualNextYear = items;
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText(
                        "bad_request"
                    )} getSavedProjectCodesActualNextYear`,
                    error.toString()
                );
            }
        },

        sortProjectsBankFormData() {
            const localName = `name_${this.lng_kz}`;
            this.projectsBankFormData.sort((a, b) =>
                a[localName].localeCompare(b[localName])
            );
        },

        prepareForSaveDecodes(event) {
            event.preventDefault();
            if (!this.goodsData.length || !this.variantAttribute) {
                this.makeToast(
                    "warning",
                    this.getErrText("msg"),
                    this.getErrText("not_saved")
                );
            }
            this.isValErrShowed = true;
            if (this.isDoubleDecodeExist()) {
                this.makeToast(
                    "warning",
                    this.getErrText("not_saved"),
                    this.getErrText("not_valid")
                );
                return;
            }
            const goodsTableFields = [
                    {
                        key: "expense_code",
                        label: this.getFormText("name_code"),
                    },
                    {
                        key: "summa",
                        label: this.getFormText("cat_sum"),
                    }
                ]
            const values = [];
            for (const row of this.goodsData) {
                if (!row.rowToSave) continue;

                if (this.isSavingForbidden(row, goodsTableFields, ['summa'], ['expense_code'])) return;
                values.push(row);
            }

            this.save(values);
        },

        isDoubleDecodeExist() {
            return this.decodeControl.some(
                (item) => item.isDouble || item.isPurposeRequired
            );
        },

        isAllDataValid() {
            const hasNotValidData = this.goodsData.some(
                (item) => !item.isDataValid
            );
            return !hasNotValidData;
        },
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.cat_sum);
            }
            return Math.ceil(sum);
        },

        categoryName() {
            const localNameField =
                this.$i18n.locale === "kk" ? "name_kk" : "name_ru";
            return `${this.currCategory.curr_code[localNameField]}`;
        },

        isFormCanBeCopied() {
            return this.expenseCodesActualNextYear.length > 0;
        },

        decodeControl() {
            const normalize = (value) => String(value ?? "").trim().toLowerCase();
            const rowsByProject = new Map();
            this.goodsData.forEach((row, index) => {
                if (!row.expense_code) return;
                if (!rowsByProject.has(row.expense_code)) {
                    rowsByProject.set(row.expense_code, []);
                }
                rowsByProject.get(row.expense_code).push(index);
            });

            const control = this.goodsData.map(() => ({
                isDouble: false,
                isPurposeRequired: false,
            }));
            rowsByProject.forEach((indexes) => {
                if (indexes.length < 2) return;
                // ru и kk считаются отдельно: совпадение ru с kk другой строки дублем не является
                const purposeKeys = indexes.map((index) => {
                    const ru = normalize(this.goodsData[index].purpose_ru);
                    const kk = normalize(this.goodsData[index].purpose_kk);
                    return [ru && `ru:${ru}`, kk && `kk:${kk}`].filter(Boolean);
                });
                const keyCounts = new Map();
                purposeKeys.flat().forEach((key) => {
                    keyCounts.set(key, (keyCounts.get(key) || 0) + 1);
                });
                indexes.forEach((rowIndex, i) => {
                    control[rowIndex].isPurposeRequired = !purposeKeys[i].length;
                    control[rowIndex].isDouble = purposeKeys[i].some(
                        (key) => keyCounts.get(key) > 1
                    );
                });
            });
            return control;
        },

        getFormText() {
            return this.setFormText("form_339.");
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "selection",
                        label: " ",
                    },
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "name_code",
                        label: this.getFormText("name_code"),
                    },
                    {
                        key: "cat_sum",
                        label: this.getFormText("cat_sum"),
                    },
                    {
                        key: "recipient",
                        label: this.getFormText("recipient"),
                    },
                    {
                        key: "purpose",
                        label: this.getFormText("purpose"),
                    },
                    {
                        key: "justif",
                        label: this.getFormText("justif"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>
<style scoped>
.error .multiselect__tags {
    padding-left: 25px;
}

.filter-actions-flex {
    display: flex;
}

.table-plus {
    border: none;
}

.bp-category-name {
    display: flex;
    justify-content: space-between;
}

</style>
